import {UseMutationOptions, useMutation} from '@tanstack/react-query';
import {
  FastAPIServiceError,
  UserFinalizePayload,
  UserFinalizeResponse,
} from '@guestapp/sdk';
import {useIsMounted} from '../common';
import {useChekinSDK} from 'context/ChekinSDK';

type Props = UseMutationOptions<
  UserFinalizeResponse,
  FastAPIServiceError,
  UserFinalizePayload
>;
function useFinishUserAccountMutation({onError, ...options}: Props = {}) {
  const {finalizeUser} = useChekinSDK();

  const isMounted = useIsMounted();

  return useMutation<UserFinalizeResponse, FastAPIServiceError, UserFinalizePayload>(
    payload => finalizeUser(payload),
    {
      onError: (error, data, variables) => {
        if (!isMounted.current) {
          return;
        }

        onError?.(error, data, variables);
      },
      ...options,
    },
  );
}

export {useFinishUserAccountMutation};
